const translations = {
  "en": {
    "24h": "24h",
    "Today PNL": "Today PNL",
    "Top Performer": "Top Performer",
    "Total PnL": "Total PnL",
    "Value": "Value"
  },
  "zh-tw": {
    "24h": "24小時",
    "Today PNL": "今日損益",
    "Top Performer": "明星資產",
    "Total PnL": "總盈虧",
    "Value": "總價值"
  }
};

export default translations;
